import { createAsyncAction } from 'typesafe-actions';
import { GetAllDebtsSuccessPayload } from '../types';

export const getAllDebts = createAsyncAction(
  'debtCentre/getAllDebts/request',
  'debtCentre/getAllDebts/success',
  'debtCentre/getAllDebts/failure'
)<undefined, GetAllDebtsSuccessPayload, undefined>();
